const readMore = () => {

    window.addEventListener('DOMContentLoaded', function () {
        var readBox = document.getElementsByClassName('read-box');
        for (var i = 0; i < readBox.length; i++) {
            var readBoxElement = readBox[i] as HTMLElement;
            if (readBoxElement.offsetHeight > 500) {
                readBox[i].classList.add('less-show');
                var readMore = readBox[i].getElementsByClassName('read-more')[0] as HTMLElement;
                readMore.style.display = "block";
            }
        }
    })

    $('.read-more').click(function () {
        $(this).parent().toggleClass('less-show');
        var text = $(this).text();
        $(this).text(
            text == "نمایش بیشتر" ? "نمایش کمتر" : "نمایش بیشتر");
        if ($(this).parent().offset().top < $(window).scrollTop()) {
            $([document.documentElement, document.body]).animate({
                scrollTop: ($(this).parent().offset().top - 200)
            }, 500);
        }
        
    });
}


export {
    readMore
};
